import { connect } from 'react-redux';
import Wall from '../../../../components/features/digitalShelf/Wall';

import { getNumberFormat } from 'core/slices/store';

import {
    setProductState,
    getExcelLandmarks,
    getDigitalShelfExcel,
    clearCoordsState,
    clearWallImageData,
    getCoordsForExcel,
    getScannedBaysInfo,
} from 'core/slices/wall';

import {
    getWallImageData,
    getCoordsInfo,
    getWallLandmarks,
    getWallsAislesData,
    getAislePromotionsList,
    getScannedBaysData,

    isLoadingAislePromotions,
    isLoadingWallImageData,
    isLoadingCoordsInfo,
    isLoadingWallLandmarks,
    isLoadingLandmarksExcel,
    isLoadingScannedBaysData,

    getExcelLandmarkList,
    getSelectedWallProduct,
    getSelectedClient,
    getAisleLandmarkState,
    loadingCoordsForExcel,
    currencySymbol,

    isLoadingMaps,
    getStoreMapsObject,
    isLoadingClientFormats,
    getClientFormats,
} from 'core/selectors';

export default connect(state => ({
    wallImageData: getWallImageData(state),
    isLoadingWallImage: isLoadingWallImageData(state),
    landmarkInfo: getCoordsInfo(state),
    isLoadingCoordsInfo: isLoadingCoordsInfo(state),
    wallLandmarks: getWallLandmarks(state),
    isLoadingLandmarks: isLoadingWallLandmarks(state),
    selectedProductState: getSelectedWallProduct(state),
    selectedClient: getSelectedClient(state),
    excelLandmarkList: getExcelLandmarkList(state),
    isLoadingLandmarksExcel: isLoadingLandmarksExcel(state),
    aislesData: getWallsAislesData(state),
    aislePromotions: getAislePromotionsList(state),
    isLoadingAislePromotions: isLoadingAislePromotions(state),
    aisleLandmarks: getAisleLandmarkState(state),
    loadingCoordsForExcel: loadingCoordsForExcel(state),
    currencySymbol: currencySymbol(state),
    isLoadingMaps: isLoadingMaps(state),
    storeMaps: getStoreMapsObject(state),
    scannedBaysData: getScannedBaysData(state),
    isLoadingScannedBaysData: isLoadingScannedBaysData(state),

    clientFormats: getClientFormats(state),
    isLoadingClientFormats: isLoadingClientFormats(state),
}), {
    setProductState,
    getExcelLandmarks,
    getDigitalShelfExcel,
    clearCoordsState,
    clearWallImageData,
    getCoordsForExcel,
    getNumberFormat,
    getScannedBaysInfo
})(Wall);
